import { render } from "./HeroiconsOutlineMap.vue?vue&type=template&id=2e0d16a4"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMap.vue"]])

export default __exports__